import {
  JWTClaimsRole,
  permissionsEnumSchema,
  psychologistHeadlineEnumSchema,
} from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { Slot } from "../../core/types";

const NorwayStrategy = {
  patientCardTabs: {
    BOOKINGS: CONSTANTS.PATIENT_CARD_TABS.BOOKINGS,
    ICBT: CONSTANTS.PATIENT_CARD_TABS.ICBT,
    PROMOCODES: CONSTANTS.PATIENT_CARD_TABS.PROMOCODES,
    ACTIONS: CONSTANTS.PATIENT_CARD_TABS.ACTIONS,
  },
  patientSearchFields: {
    FIRSTNAME: CONSTANTS.SEARCH_TERMS.FIRSTNAME,
    LASTNAME: CONSTANTS.SEARCH_TERMS.LASTNAME,
    USER_ID: CONSTANTS.SEARCH_TERMS.USER_ID,
    EMAIL: CONSTANTS.SEARCH_TERMS.EMAIL,
  },
  psychologist: {
    userData: {
      rows: [
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .EDITABLE_PHONE_AND_UNEDITABLE_EMAIL,
      ],
    },
    headlineKeys: [psychologistHeadlineEnumSchema.enum.authorised],
    hasRequiredAdeli: false,
    hasPersonnummer: false,
  },
  specialities: {
    hasFilteredSpecialities: false,
  },
  slots: {
    isPayable: true,
  },
  marketHasStatisticsDashboard: false,
  slotTemplates: [
    CONSTANTS.SLOT_TEMPLATES.NEW_VISIT,
    CONSTANTS.SLOT_TEMPLATES.TECH_TEST,
    CONSTANTS.SLOT_TEMPLATES.BLOCKER,
    CONSTANTS.SLOT_TEMPLATES.REVISIT,
  ],
  patientCard: {
    status_label: "STATUS",
  },
  showEditPatientDetails: true,
  showRevisitLabelSuffix: false,
  showInsuranceInfoPsychologist: false,
  showInsuranceInfoAdmin: false,
  showInsurancePlan: false,
  showSavedCardStatus: false,
  showExtraInfoPatientBookings: false,
  showSessionCountColumn: false,
  changeSlotStatus: {
    enabled: true,
    enabledForRoles: [] as JWTClaimsRole[],
    enabledForPermission: permissionsEnumSchema.enum.EDIT_PATIENT_DETAILS,
    feeStatuses: [] as Slot["status"][],
    getSlotStatuses: () => {
      return CONSTANTS.UPDATABLE_BOOKING_STATUS;
    },
  },
  clinicalGuidelinesHref:
    "https://docs.google.com/document/d/1VpM6d2ze9Q9YgobCcU_BybunrZaeb28VKHdWC7Q9TWw/edit?tab=t.0",
};

export default NorwayStrategy;
